/**
 * Escapes HTML special characters so a string can be safely inserted
 * into HTML content or attribute values.
 *
 * Escapes both single and double quotes for safety.
 */
export function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
